import { ArrowDownS16, ArticleParagraph2 } from '@cian/ui-kit';
import * as React from 'react';
import cn from 'classnames';
import styles from './AreaPartExpandButton.css';

import { IAreaPartExpandButtonProps } from './types';

export const AreaPartExpandButton: React.FC<IAreaPartExpandButtonProps> = props => {
  const { expanded, active, onClick } = props;

  const title = expanded ? 'Свернуть' : 'Развернуть';

  return (
    <div className={styles['expand-button']} onClick={onClick} role="button">
      <ArticleParagraph2 color={active ? 'primary_100' : 'gray10_100'}>{title}</ArticleParagraph2>
      <div className={cn(styles['arrow'], { [styles['rotated']]: expanded })}>
        <ArrowDownS16 color={active ? 'primary_100' : 'gray10_100'} />
      </div>
    </div>
  );
};
